import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";
import {getParam} from "../../components/Utils/Utils";

const selectApprovalGroups = async (search, pageable) => {
    try {
        return await needAuth.post(`/approvalGroups?${getParam(pageable)}`, search);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
};

const selectApprovalGroupsByProcessId = async (processId) => {
    try {
        return await needAuth.get(`/approvalGroups/approvalProcesses/${processId}`);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

export {
    selectApprovalGroups,
    selectApprovalGroupsByProcessId,
};
